import React from "react";
import { TableHead, TableRow, TableCell } from "@mui/material";

const UserAddressesTableHead = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Ulica</TableCell>
                <TableCell>Broj</TableCell>
                <TableCell>Grad</TableCell>
                <TableCell>Poštanski broj</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
            </TableRow>

        </TableHead>
    );
};

export default UserAddressesTableHead;
